import httpClient from './httpClient';
import { TypeOfUser } from '../helpers/Constants';
import Routes from '../helpers/Routes';
import { ISendbirdGroupAddMetadata } from '../models/ChatModels';

const {
  chat: { channels, channel, chats, sendbirdBasePath, metadata, unreadCount },
  pharmacy: { basePath: pharmacyBasePath },
  user: { userBasePath },
  professional: { professionalBasePath },
  general: { hide },
} = Routes;

class ChatController {
  adminBasePath: string;
  sendbirdBasePath: string;

  constructor() {
    this.adminBasePath = Routes.admin.adminBasePath;
    this.sendbirdBasePath = sendbirdBasePath;
  }

  createGroupChannel = async (
    userType: Omit<
      TypeOfUser,
      TypeOfUser.admin | TypeOfUser.pharmacyAdmin | TypeOfUser.superAdmin
    >
  ) => httpClient.get(`/${userType}${channel}`);

  adminCreateGroupChannel = async (userId: string) =>
    httpClient.get(`${this.adminBasePath}${channel}/${userId}`);

  addGroupMetadata = async (params: ISendbirdGroupAddMetadata) =>
    httpClient.post(`${this.sendbirdBasePath}${channels}${metadata}`, params);

  adminCloseChat = async (groupUrl: string) =>
    httpClient.delete(`${this.sendbirdBasePath}${chats}/${groupUrl}`);

  createChatFromPharmacy = (professionalId: string) =>
    httpClient.get(
      `${Routes.pharmacy.basePath}${Routes.general.channel}/${professionalId}`
    );

  createChatFromProfessional = (pharmacyId: string) =>
    httpClient.get(
      `${Routes.professional.professionalBasePath}${Routes.general.channel}/${pharmacyId}`
    );

  professionalHidesChat = (channelUrl: string) =>
    httpClient.post(`${professionalBasePath}${channel}${hide}`, {
      channelUrl,
    });

  pharmacyHidesChat = (channelUrl: string) =>
    httpClient.post(`${pharmacyBasePath}${channel}${hide}`, {
      channelUrl,
    });
}

export default new ChatController();
